import styled from 'styled-components';
import { boxFlex } from './../../styled/index';
import { detectMobile } from '../../utils/UiHelper';

export const ComboModalCont = styled(boxFlex)`
    width: 100%;
    max-width: ${detectMobile() ? '100%' : '390px'};
    background: #fff;
    border-radius: 8px;
    position: relative;
    z-index: 1;
`;
export const ComboModalTop = styled(boxFlex)`
    width: 100%;
    border-bottom: 1px solid #dfe5ed;
    position: relative;
`;
